export default [
    {
		path: "/tests",
		component: () => import("../views/Tests/List.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/tests/new/:testId?",
		component: () => import("../views/Tests/New.vue"),
	},
	{
		path: "/tests/viewall/:list?",
		component: () => import("../views/Tests/ViewAll.vue")
	},
	{
		path: "/tests/:competencytestid?",
		component: () => import("../views/Tests/View.vue"),
	},
]
